import { useEffect, useRef, useState } from "react";
import { Input, Spinner } from "reactstrap";
import { Search } from "lucide-react";
import { useNavigate } from "react-router-dom";

import GroupService from "../../module/Group Module/Services/GroupService";

import "./SmartSearch.css";
import { SearchSuggestion } from "../../module/Group Module/types/Group";
interface Props {
    onSearchResult: (hasResults: boolean) => void;
    onKeywordChanged: (keyword: string) => void;
}
const SmartSearch = ({
    onSearchResult,
    onKeywordChanged
}: Props) => {

    const navigate = useNavigate();

    const [keyword, setKeyword] = useState("");

    const [loading, setLoading] = useState(false);

    const [suggestions, setSuggestions] =
        useState<SearchSuggestion[]>([]);

    const [showDropdown, setShowDropdown] =
        useState(false);

    const wrapperRef =
        useRef<HTMLDivElement>(null);

    //------------------------------------------
    // Search
    //------------------------------------------

    useEffect(() => {

        if (keyword.trim().length < 2) {

            setSuggestions([]);

            setShowDropdown(false);

            onSearchResult(true);

            onKeywordChanged("");

            return;

        }
        const timer = setTimeout(async () => {

            try {

                setLoading(true);

                const result =
                    await GroupService.getSearchSuggestions(keyword);

                setSuggestions(result);

                setShowDropdown(true);
                onSearchResult(result.length > 0);

                onKeywordChanged(keyword);
            }
            catch {

                setSuggestions([]);

                setShowDropdown(false);
                onSearchResult(false);

                onKeywordChanged(keyword);
            }
            finally {

                setLoading(false);

            }

        }, 400);

        return () => clearTimeout(timer);
        // eslint-disable-next-line
    }, [keyword]);

    //------------------------------------------
    // Click Outside
    //------------------------------------------

    useEffect(() => {

        const handleClickOutside = (
            event: MouseEvent
        ) => {

            if (
                wrapperRef.current &&
                !wrapperRef.current.contains(
                    event.target as Node
                )
            ) {

                setShowDropdown(false);

            }

        };

        document.addEventListener(
            "mousedown",
            handleClickOutside
        );

        return () => {

            document.removeEventListener(
                "mousedown",
                handleClickOutside
            );

        };

    }, []);

    const words = [
        "NEET",
        "Python",
        "JEE",
        "AI ML",
        "CAD Design",
        "Data Science",
        "Full Stack",
    ];

    const [placeholder, setPlaceholder] = useState("");
    const [isFocused, setIsFocused] = useState(false);

    useEffect(() => {
        if (isFocused || keyword.length > 0) {
            setPlaceholder("");
            return;
        }

        let wordIndex = 0;
        let charIndex = 0;
        let timer: ReturnType<typeof setTimeout>;

        const animate = () => {
            const word = words[wordIndex];

            if (charIndex < word.length) {
                setPlaceholder(word.slice(0, ++charIndex));
                // Typing speed (smaller = faster)
                timer = setTimeout(animate, 80);
            } else {
                timer = setTimeout(() => {
                    // Instantly clear
                    setPlaceholder("");
                    charIndex = 0;
                    wordIndex = (wordIndex + 1) % words.length;

                    // Delay before starting the next word
                    timer = setTimeout(animate, 250);   //m ,250, 500

                    // How long the completed word stays visible
                }, 700);
            }
        };

        animate();

        return () => clearTimeout(timer);
        // eslint-disable-next-line 
    }, [isFocused, keyword]);



    //------------------------------------------

    return (

        <div 
            className="smart-search"
            ref={wrapperRef}
        >

            <div className="google-search-box">

                <Search
                    size={20}
                    className="search-icon"
                />

                <Input
                    value={keyword}
                    onChange={(e) => setKeyword(e.target.value)}
                    placeholder={placeholder}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    autoComplete="off"
                />

                {
                    loading &&
                    <Spinner size="sm" />
                }

            </div>

            {
                showDropdown &&

                <div className="smart-dropdown">

                    {

                        suggestions.length > 0 ?

                            suggestions.map(item => (

                                <div
                                    key={
                                        item.groupId ??
                                        item.title
                                    }
                                    className="smart-item"
                                    onClick={() => {

                                        setShowDropdown(false);

                                        if (item.groupId) {

                                            navigate(
                                                `/groups/${item.slug}`
                                            );

                                        }

                                    }}
                                >

                                    <div className="smart-title">

                                        {item.title}

                                    </div>

                                    <small className="smart-subtitle">

                                        {item.subtitle}

                                    </small>

                                </div>

                            ))

                            :

                            <div className="smart-item text-muted">

                                No results found

                            </div>

                    }

                </div>

            }

        </div>

    );

};

export default SmartSearch;